// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__13KL_","content":"Tooltip_content__3bLPJ","active":"Tooltip_active__36kkO","element":"Tooltip_element__1eIYY","showTooltip":"Tooltip_showTooltip__30XqS"};